import * as Yup from 'yup';

export const schema = Yup.object().shape({
    fullName: Yup.string()
        .trim()
        .matches(/(\w.+\s).+/i)
        .required(),
    email: Yup.string()
        .email()
        .required(),
    position: Yup.string()
        .trim()
        .required(),
    departmentName: Yup.string()
        .trim()
        .required(),
    cpf: Yup.string()
        .matches(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/, { excludeEmptyString: true })
        .notRequired(),
});

export const formInitialState = {
    fullName: '',
    email: '',
    position: '',
    departmentName: '',
    cpf: '',
};

export const formErrors = {
    fullNameError: false,
    emailError: false,
    positionError: false,
    departmentError: false,
    cpfError: false,
};
